import styled from 'styled-components'

export const MenuImage = styled.img`
  width: 100%;
  max-width: 636px;
`
